import { useContext, useState } from 'react';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';


export function AddStaff({ setShowStaffModal, locations, getData }) {
  const {logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [formFields, setFormFields] = useState({});

    const handleSubmit = async () => {
    const formData = new FormData();
    Object.entries(formFields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    setLoading(true)
    try {
        const response = await axios.post(base_url + '/add_staff.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                accountid: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setTostMessage({
                messageType: 'success',
                message: response.data.message
            })
            getData();
            setShowStaffModal(false);
        } else {
        setTostMessage({
            messageType: 'error',
            message: response.data.message
        })
        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };
    
  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div className='w-[80%] flex justify-end text-underline text-[#ff0000]'>
                    <p className='cursor-pointer' onClick={() => setShowStaffModal(false)}>Cancel</p>
                </div>
                <a className='text-dark text-[17px] font-bold'>Add New Staff</a>
                <a className='text-dark text-[15px] font-semibold'>{'Please fill the form appropriately'}</a>
                    <div className="w-[80%] mx-auto flex flex-col mt-2">
                        <label>Location</label>
                        <select
                            className="w-full mx-auto border p-2 rounded my-2"
                            onChange={(e) => setFormFields({...formFields, location_id: e.target.value})}
                        >
                            <option value="">All Locations</option>
                            {locations?.map((item, index) => 
                                <option key={index} value={item.location_id}>{item.name}</option>
                            )}
                        </select>
                    </div>
                    <div className="w-[80%] mx-auto flex flex-col mt-2">
                        <label>Role</label>
                        <select
                            className="w-full mx-auto border p-2 rounded my-2"
                            onChange={(e) => setFormFields({...formFields, role: e.target.value})}
                        >
                            <option value="">Choose Role</option>
                            <option value="Super-Admin">Super-Admin</option>
                            <option value="Manager">Manager</option>
                            <option value="Attendant">Attendant</option>
                        </select>
                    </div>
                  <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Full Name</label>
                    <input type='default' onChange={(e) => setFormFields({...formFields, full_name: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Full Name" />
                  </div>
                  <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Email (Login ID)</label>
                    <input type='default' onChange={(e) => setFormFields({...formFields, email: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Email (Login ID)" />
                  </div>
                  <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Password</label>
                    <input type='default' onChange={(e) => setFormFields({...formFields, password: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Login Password" />
                  </div>
                    <div className="flex justify-between mt-5">
                        <button
                            onClick={handleSubmit}
                            className="
                            bg-[#037684] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Add User
                        </button>
                    </div>
                    {loading ? (
                        <ClockLoader
                            color={'#212121'}
                            loading={loading}
                            size={25}
                            className='mt-3'
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                        ) : null
                    }
            </div>  
        </div>
    )
}

